module.exports = __webpack_public_path__ + "static/antd-datepicker-format-06d2cd02cee8a90ab0c945d53e7e3c40.png";